import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateViaAuthGuard } from 'yardi-angular-framework-bootstrap';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/deal-dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/user-profile.module').then(m => m.UserProfileModule)
  },
  {
    path: 'deal-dashboard',
    loadChildren: () => import('./pages/deal-dashboard/deal-dashboard.module').then(m => m.DealDashboardModule)
  },
  {
    path: 'document',
    loadChildren: () => import('./pages/document/document.module').then(m => m.DocumentModule)
  },
  {
    path: 'deal',
    loadChildren: () => import('./pages/deal-dashboard/deal-room/deal-room.module').then(m => m.DealRoomModule)
  },
  {
    path: 'datarooms-modal',
    redirectTo: '/',
    pathMatch: 'full'
  },
  // {
  //   path: 'profile',
  //   loadChildren: () => import('./pages/profile/user-profile.module').then(m => m.UserProfileModule)
  // }
  //,
  // {
  //   path: 'homepage',
  //   loadChildren: () => import('./pages/homepage/homepage.module').then(m => m.HomepageModule)
  // },
  // {
  //   path: 'document',
  //   loadChildren: () => import('./pages/document/document.module').then(m => m.DocumentModule)
  // },
  // {
  //   path: 'profile',
  //   loadChildren: () => import('./pages/profile/user-profile.module').then(m => m.UserProfileModule)
  // },
  // {
  //   path: 'investment',
  //   loadChildren: () => import('./pages/investment/investment-list/investment-list.module').then(m => m.InvestmentListModule)
  // },
  // {
  //   path: 'accountactivity',
  //   loadChildren: () => import('./pages/accountactivity/accountactivity.module').then(m => m.AccountActivityModule),
  // },
  // {
  //   path: 'opportunity/summary/:OpportunityId',
  //   loadChildren: () => import('./pages/opportunities/summary/opportunity-summary/opportunity-summary.module').then(m => m.OpportunitySummaryModule)
  // },
  // {
  //   path: 'opportunity',
  //   loadChildren: () => import('./pages/opportunities/opportunities.module').then(m => m.OpportunitiesModule)
  // },
  // {
  //   path: 'contactus',
  //   loadChildren: () => import('./pages/contactus/contactus.module').then(m => m.ContactUsModule)
  // },
  // {
  //   path: 'transactions',
  //   loadChildren: () => import('./pages/transactions/transactions.module').then(m => m.TransactionModule)
  // },
  // {
  //   path: '**', redirectTo: '/dashboard'
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
